module.exports = __webpack_public_path__ + "assets/img/title-7f53d631.png";